// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"24":"3c7ab086","527":"4011fd06","541":"b14297f2","752":"b14297f2","941":"344fc770"}[chunkId] + ".chunk.css";
};